import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { ClothesSizeOptions, FormTypeAdd, FormTypeEdit, ShoesSizeOptions } from "utils/Constant";
import { GetPriceAfterTax, GetStatus, money, removeNonNumeric } from "utils/helpers";
import { useModal } from "context/ModalContext";
import Select from 'react-select'
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards";
import { SalesStockService } from "services/SalesStockService/SalesStockService";
import { ProductService } from "services/ProductService/ProductService";
import { SystemService } from "services/SystemService/SystemService";

export default function SalesStockForm(){
    let navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCreateSalesStock, fetchUpdateSalesStock, fetchSalesStockById } = SalesStockService()
    const { fetchProductList } = ProductService()
    const { fetchSystem } = SystemService()
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let salesStockId = queryString.get("salesStockId")

    const [productOptions, setProductOptions] = useState([])
    const [product, setProduct] = useState({})
    const [stockIn, setStockIn] = useState(new Date())
    const [purchasePrice, setPurchasePrice] = useState('')
    const [sellingPrice, setSellingPrice] = useState('0')
    const [discount, setDiscount] = useState('0')
    const [priceAfterDiscount, setPriceAfterDiscount] = useState('')
    const [quantity, setQuantity] = useState('1')
    const [tax, setTax] = useState('')
    const [size, setSize] = useState('')
    const [categoryId, setCategoryId] = useState('')
    const [categoryName, setCategoryName] = useState('')

    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    
    // Button Event
    const saveBtnClick = async () => {
        if (!validation()) return

        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            if (formType === FormTypeAdd) {
                const res = await fetchCreateSalesStock(
                    product.value,
                    moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                    purchasePrice.replaceAll(',',''),
                    sellingPrice.replaceAll(',', ''),
                    discount,
                    quantity,
                    size
                )
                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        navigate("/sales-stock") 
                    }
                })
            } else {
                const res = await fetchUpdateSalesStock(
                    salesStockId,
                    product.value,
                    moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                    purchasePrice.replaceAll(',',''),
                    sellingPrice.replaceAll(',', ''),
                    discount,
                    size
                )
                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        navigate("/sales-stock") 
                    }
                })
            }   
        }
        finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    // Function
    const validation = () => {
        if (product === null){
            showFail('Product is required!')
            return false
        } else if (product.value === '') {
            showFail('Product is required!')
            return false
        }
        if (stockIn === null) {
            showFail('Stock In Date is required!')
            return false
        }
        if (purchasePrice === '') {
            showFail('Purchase Price is required!')
            return false
        }
        if (sellingPrice === '') {
            showFail('Selling Price is required!')
            return false
        }
        if (discount === '') {
            showFail('Discount is required!')
            return false
        } else {
            if (parseInt(discount) > 100){
                showFail('Discount cannot exceeded 100!')
                return false
            }
        }
        if (quantity === '' || quantity === '0') {
            showFail('Quantity is required!')
            return false
        }

        return true
    }

    useEffect(() => {
        if (sellingPrice !== ''){
            let disc = discount === '' ? 0 : parseFloat(discount)
            let finalPrice = parseFloat(sellingPrice.replaceAll(',', '')) * (100 - disc) / 100

            setPriceAfterDiscount(Math.round(finalPrice))
        }
    }, [sellingPrice, discount])
    
    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                const res = await fetchSystem('tax')
                if (!res) return

                setTax(res.data.systemValue)

                if (formType === FormTypeEdit) {
                    const res = await fetchSalesStockById(salesStockId)
                    if (!res) return 

                    const data = res.data

                    // Data
                    setProduct({ label: data.brandName + ' ' + data.productName.toUpperCase(), value: String(data.productId), categoryId: String(data.categoryId), categoryName: data.categoryName })
                    setCategoryName(data.categoryName)
                    setSize(data.size)
                    setStockIn(data.stockIn)
                    setPurchasePrice(money(data.purchasePrice))
                    setSellingPrice(money(Math.round(data.sellingPrice)))
                    setDiscount(data.discount === '' ? '0' : data.discount)

                    // Header
                    setStatus(data.status)
                    setCreateBy(data.createBy)
                    setCreateDate(data.createDate)
                    setUpdateBy(data.updateBy)
                    setUpdateDate(data.updateDate)
                } else {
                    const res = await fetchProductList('', '', '1', 2000, 0)
                    if (!res) return

                    let data = res?.data?.listData
                    let tempData = [{ label: 'Select Product', value: '' }]

                    data.map((data) => tempData.push({ label: data.brandName + ' ' + data.productName.toUpperCase(), value: String(data.productId), price: data.price, discount: data.discount, priceAfterDiscount: data.nettPrice, categoryId: String(data.categoryId), categoryName: data.categoryName }))

                    setProductOptions(tempData)
                }
            }
            finally {
                hideLoading()
            }
        }
        
        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <div>
                <PagesFormTitle
                    title='Detail Stock Penjualan'
                    formType={formType}
                    status={status}
                    createDate={createDate}
                    updateDate={updateDate}
                    updateBy={updateBy}
                />

                <div className="mt-5 flex flex-col gap-3 ">
                    {/* Product */}
                    <FormCard title='Product'>
                        <Select options={productOptions} value={product} 
                            onChange={(e) => { setProduct(e); setSellingPrice(money(e.price)); setDiscount(e.discount); setPriceAfterDiscount(e.priceAfterDiscount); }} 
                            placeholder='Select Product' 
                            isDisabled={formType === FormTypeEdit ? true : false}
                        />
                    </FormCard>

                    <FormCard title='Category'>
                        <span>{product.categoryName}</span>
                    </FormCard>

                    {product.categoryId !== null && (product.categoryId === '3' || product.categoryId === '8') && 
                        <FormCard title='Size'>
                            <div className="flex gap-2">
                                {product.categoryId === '3' && 
                                    ShoesSizeOptions.map((data, i) => 
                                        <button 
                                            className={`px-3 py-1 border rounded-full ${size === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                            onClick={() => setSize(data.value)}
                                            key={i}
                                        >
                                            {data.label}
                                        </button>
                                    )
                                }
                                {product.categoryId === '8' && 
                                    ClothesSizeOptions.map((data, i) => 
                                        <button 
                                            className={`px-3 py-1 border rounded-full ${size === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                            onClick={() => setSize(data.value)}
                                            key={i}
                                        >
                                            {data.label}
                                        </button>
                                    )
                                }
                            </div>
                        </FormCard>
                    }

                    {/* Stock In Date */}
                    <FormCard title='Stock In Date'>
                        <DatePicker value={stockIn} onChange={(e) => { setStockIn(e) }} className='h-11 w-full bg-white' disableClock={true} />
                    </FormCard>
                    
                    {/* Purchase Price */}
                    <FormCard title='Purchase Price'>
                        <input className="input" value={purchasePrice} onChange={(e) => { setPurchasePrice(money(e.target.value)) }} maxLength={12} />
                    </FormCard>

                    {/* Selling Price */}
                    <FormCard title='Selling Price'>
                        <span className="">Rp {sellingPrice}</span>
                    </FormCard>
                    
                    {/* Discount */}
                    <FormCard title='Discount'>
                        <div className="flex items-center w-24">                                
                            <span className="">{discount} %</span>
                        </div>
                    </FormCard>

                    {/* Tax */}
                    <FormCard title='Tax'>
                        <div className="flex items-center w-24">                                
                            <span className="">{tax} %</span>
                        </div>
                    </FormCard>
                    
                    {/* Final Price */}
                    <FormCard title='Final Price'>
                        <span className="font-semibold">Rp {money(GetPriceAfterTax(priceAfterDiscount, tax))}</span>
                    </FormCard>

                    {/* Quantity */}
                    {formType === FormTypeAdd && 
                        <FormCard title='Quantity'>
                            <div className="flex gap-2">
                                <button className="button" onClick={() => { setQuantity(prev => Math.max(0, parseInt(prev) - 1)) }}> - </button>
                                <div className="w-20">
                                    <input className="input" value={quantity} onChange={(e) => { setQuantity(removeNonNumeric(e.target.value)) }} maxLength={12} />
                                </div>
                                <button className="button" onClick={() => { setQuantity(prev => Math.max(0, parseInt(prev === '' ? 0 : prev) + 1)) }}    > + </button>
                            </div>
                        </FormCard>
                    }
                </div>
            </div>            

            {/* Button */}
            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <BackButton onClick={backBtnClick} />
            </div>
        </MainBodyCard>
        
    )
}